<nb-icon *ngIf="value; else unmatchedIcon" icon="checkmark-outline" status="success"> </nb-icon>
<ng-template #unmatchedIcon>
    <nb-icon icon="close-outline"></nb-icon>
</ng-template>
